var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{staticClass:"error-popup",attrs:{"title":_vm.$t('alerts.connectionClosed.title'),"showPopup":_vm.showPopup,"noClose":""},on:{"close-modal":function($event){return _vm.$emit('close-modal', $event)}}},[_c('connection-error')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }